import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import React, { useState, useEffect, useCallback } from 'react';
import { Root, H3 } from './common/styled';
import { memoNamed } from '../utils/react/memo-named';
import { BoardSendPost } from './BoardSendPost';
import { BoardView } from './BoardView';
import { BoardCategory, boardPostWithDefault, BoardPost } from '../types/board';
import { hasPrivilege, userWithDefault } from '../types/user';

interface Props {
  isAdmin: boolean;
}

export const Board = memoNamed<Props>('Board', (props) => {
  const [category, setCategory] = useState<BoardCategory>('others');
  const [hasPrivilegeUser, setHasPrivilegeUser] = useState<boolean>(false);
  const [postInfoList, setPostInfoList] = useState<
    { post: BoardPost; docID: string }[]
  >([]);
  const [startKeyNext, setStartKeyNext] = useState<
    firebase.firestore.Timestamp
  >(firebase.firestore.Timestamp.fromDate(new Date()));

  const updatePost = useCallback(() => {
    const db = firebase.firestore();
    db.collection('Board')
      .where('isPublic', '==', true)
      .where('category', '==', category)
      .orderBy('postTime', 'desc')
      .startAt(firebase.firestore.Timestamp.fromDate(new Date()))
      .limit(10)
      .get()
      .then((snapshot) => {
        setPostInfoList(
          snapshot.docs.map((u, i) => {
            const _post = boardPostWithDefault(u.data() as object);
            if (i === snapshot.docs.length - 1) setStartKeyNext(_post.postTime);
            return { post: _post, docID: u.id };
          })
        );
      })
      .catch((error) => console.error(error));
  }, [category]);

  // check privilege
  useEffect(() => {
    const uid = firebase.auth().currentUser?.uid ?? '';
    const db = firebase.firestore();
    db.collection('Users')
      .where('userID', '==', uid)
      .get()
      .then((snapshot) => {
        if (snapshot.size !== 1) return;
        setHasPrivilegeUser(
          hasPrivilege(userWithDefault(snapshot.docs[0].data()).privilegePeriod)
        );
      })
      .catch((error) => console.error(error));
    updatePost();
  }, [updatePost]);

  return (
    <Root>
      <H3>掲示板</H3>
      {props.isAdmin || hasPrivilegeUser ? (
        <BoardSendPost
          isAdmin={props.isAdmin}
          category={category}
          setCategory={setCategory}
          setPostInfoList={setPostInfoList}
          updatePost={updatePost}
        />
      ) : undefined}
      <br />
      <BoardView
        isAdmin={props.isAdmin}
        category={category}
        setCategory={setCategory}
        postInfoList={postInfoList}
        setPostInfoList={setPostInfoList}
        updatePost={updatePost}
        setStartKeyNext={setStartKeyNext}
        startKeyNext={startKeyNext}
      />
    </Root>
  );
});
